import { Link } from 'react-router-dom';

import { CreditAuthoritySettings } from '@/features/creditAuthority/CreditAuthoritySettings';
import { useAuth } from '@/shared/auth/useAuth';
import { Card, CardBody, CardHeader } from '@/shared/ui/Card';

import { vePareceresEAlcadas } from './acesso';
import { ROTA_DO_CONSUMO, ROTA_DO_SIMULADOR } from './EditorDeParametros';

const destinos = [
  {
    para: '/configuracoes/credito',
    titulo: 'Parametros do motor de credito',
    texto:
      'Versao ativa, rascunho, historico de versoes, comparacao, regras homologadas e heranca do padrao global.',
  },
  {
    para: ROTA_DO_CONSUMO,
    titulo: 'Consumo de consultas',
    texto:
      'Consultas a SeguraCoreCredit no mes, limite de quantidade e limite financeiro.',
  },
  {
    para: ROTA_DO_SIMULADOR,
    titulo: 'Simulador',
    texto:
      'O mesmo motor das analises reais, com dados ficticios: nao consulta a SeguraCoreCredit e nao altera analise.',
  },
];

/**
 * Entrada "Analise de credito" no menu de Configuracoes.
 *
 * A configuracao da analise tem paginas proprias, porque cada uma muda por um motivo
 * diferente: os parametros sao politica de credito, o consumo e custo, e o simulador e
 * conferencia antes de ativar.
 *
 * Abaixo, a secao "Pareceres, alcadas e bloqueios" (C-ALC), para quem le a matriz de
 * alcadas ou a politica de credito, com a funcionalidade `credito.analise`. Cada
 * assunto da secao tem versao propria, com rascunho, ativacao por outra pessoa e
 * vigencia.
 */
export function EntradaDaAnaliseDeCredito() {
  const { can, hasFeature } = useAuth();
  const veParametros = can('credito.parametro.view');
  const veAlcadas = vePareceresEAlcadas(can, hasFeature);
  return (
    <div className="flex flex-col gap-5">
      {veParametros ? (
        <Card>
          <CardHeader
            title="Analise de credito"
            description="Parametros do motor, consumo das consultas e simulador."
          />
          <CardBody className="grid gap-3 md:grid-cols-3">
            {destinos.map((destino) => (
              <Link
                key={destino.para}
                to={destino.para}
                className="flex flex-col gap-1 rounded-md border border-line p-4 hover:border-brand-500"
              >
                <span className="text-sm font-semibold text-brand-700">
                  {destino.titulo}
                </span>
                <span className="text-xs text-ink-600">{destino.texto}</span>
              </Link>
            ))}
          </CardBody>
        </Card>
      ) : null}
      {veAlcadas ? (
        <section
          aria-labelledby="secao-pareceres-alcadas"
          className="flex flex-col gap-3"
        >
          <div className="flex flex-col gap-1">
            <h2
              id="secao-pareceres-alcadas"
              className="text-base font-semibold text-ink-900"
            >
              Pareceres, alcadas e bloqueios
            </h2>
            <p className="text-sm text-ink-600">
              O que cada parecer exige, os niveis de alcada por tipo de decisao, os
              bloqueios de emissao e o motor no envio para analise. Sem versao ativada,
              vale o padrao.
            </p>
          </div>
          <CreditAuthoritySettings />
        </section>
      ) : null}
    </div>
  );
}
